export const incBal = () => {
  return {
    type: "inc"
  };
};

export const decBal = () => {
  return {
    type: "dec"
  };
};

export const resetBal = () => {
  return {
    type: "reset"
  };
};
